<template>
  <LayoutBase>
    <BasicAppHeader zen-mode />

    <v-layout class="overflow-inherit!" style="z-index: inherit">
      <v-main class="pt-20! md:pt-30! pb-12!">
        <slot />
      </v-main>
    </v-layout>

    <CreditAppFooter />
  </LayoutBase>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  LayoutBase,
  CreditAppFooter,
  BasicAppHeader,
} from "@/components/layout";

/**
 * Layout for anonymous resources. Uses by pages for published item and business profile permalinks.
 * The intention is to remove distracting Orie links and just basic logo and links
 */
export default defineComponent({
  components: {
    LayoutBase,
    CreditAppFooter,
    BasicAppHeader,
  },
});
</script>
